import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
	state:{
		loading: false,
		listaPaises: [],
		listaPerfis: [],
		listaStatus: [],
		listaClas: [],
		listaLocais: [],
		corEvento: 'primary',
		title: 'Inicio',
		timePickerOption: {
			start: '00:00',
			end: '23:59',
			step: '00:01'
		},
		timePickerOptionEvento: {
			start: '00:00',
			end: '23:55',
			step: '00:05'
		},
		lendoArtigo: false,
		isMenuVisible: true,
		// user: {
		// 	acessos:{

		// 	},
		// 	dados: {

		// 	},
		// 	residencial: {

		// 	},
		// 	comercial: {

		// 	},
		// 	outros:{
				
		// 	}
		// },
		user: null,
		buscandoDados: false,
		iniciado: {
			imagem: '',
			dados: {},
			residencial: {},
			comercial: {},
			outros:{},
			passagens:{},
			clas: {},
			titulos: {}
		},
		iniciadoPadrao: {
			dados: {},
			residencial: {},
			comercial: {},
			outros:{},
			passagens:{},
			clas: {},
			titulos: {}
		},
		itemPassagem: {}
	},

	getters: {
		alturaContent: () => {
			return window.innerHeight - 84
		}
	},
	mutations: {
		toggleMenu(state, isVisible){
			if(isVisible === undefined){
				state.isMenuVisible = !state.isMenuVisible
			}else{
				state.isMenuVisible = isVisible
			}
		},

		setUser(state, user){
			state.user = user
			if(user){
				state.isMenuVisible = true
			}else{
				delete axios.defaults.headers.common['Authorization']
				state.isMenuVisible = false
			}
		},
		
		alteraBuscandoDados(state, acao){
			state.buscandoDados = acao
		},

		alteraLendoArtigo(state, acao){
			state.lendoArtigo = acao
		},

		setIniciado(state, iniciado){
			state.iniciado = iniciado
		},

		setTitle(state, payload){
			state.title = payload
		},

		setCorEvento(state, payload){
			state.corEvento = payload
		},
		setNovoEvento(state, payload){
			state.novoEvento = payload
		},

		setClas(state, payload){
			state.listaClas = payload
		},

		setPerfis(state, payload){
			state.listaPerfis = payload
		},

		setStatus(state, payload){
			state.listaStatus = payload
		},

		setPaises(state, payload){
			state.listaPaises = payload
		},

		setLocais(state, payload){
			state.listaLocais = payload
		},
		
		setItemPassagem(state, payload){
			state.itemPassagem = payload
		},

		setImagem(state, payload){
			state.iniciado.imagem = payload
		},

		setLoading(state, payload){
			state.loading = payload
		},

	}
})